var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('data-section',{attrs:{"theme":"blue","title":"其他產險-火險","isLoading":_vm.isLoading,"datas":_vm.highlightModify,"_fields":[
      {
        name: '保單號碼',
        key: 'ceplcno',
        width: 155,
        sortable: true,
        orderByMultiKey: ['ceplcno'],
        orderByMultiType: ['asc'],
      },
      {
        name: '產險公司',
        key: 'comp_nm',
        width: 410,
        sortable: true,
        orderByMultiKey: ['comp_nm'],
        orderByMultiType: ['asc'],
      },
      {
        name: '契約別',
        key: 'contract_type',
        width: 110,
        sortable: true,
        orderByMultiKey: ['contract_type'],
        orderByMultiType: ['asc'],
      },
      {
        name: '被保人',
        key: 'ceisdnm',
        width: 94,
        sortable: true,
        className: 'link text-underline',
        orderByMultiKey: ['ceisdnm'],
        orderByMultiType: ['asc'],
      },
      {
        name: '有效期間',
        key: 'celpsdt',
        width: 110,
        sortable: true,
        className: 'text-left',
        orderByMultiKey: ['celpsdt'],
        orderByMultiType: ['asc'],
      },
      {
        name: '保費',
        key: 'premium',
        width: 83,
        sortable: true,
        thClassName: 'text-right',
        className: 'text-right',
        orderByMultiKey: ['premium1'],
        orderByMultiType: ['asc'],
      },
      {
        name: '建築完工年份',
        key: 'target_birth',
        width: 108,
        sortable: true,
        className: 'text-left',
        orderByMultiKey: ['target_birth'],
        orderByMultiType: ['asc'],
      } ].concat(_vm._fields),"initShow":_vm.$route.query['OtherPropertyFireInsuranceShow'] !== 'false'},on:{"toggle":function (isShow) { return _vm.$router.assignQuery({ OtherPropertyFireInsuranceShow: isShow }); }},scopedSlots:_vm._u([{key:"default",fn:function(props){return _vm.refresh?[_c('data-table',_vm._b({attrs:{"initSort":_vm.$route.query["OtherPropertyFireInsuranceSort"]
          ? JSON.parse(_vm.$route.query["OtherPropertyFireInsuranceSort"])
          : null},on:{"changeSort":function (sort) {
              var _obj;

              return _vm.$router.assignQuery(( _obj = {}, _obj["OtherPropertyFireInsuranceSort"] = JSON.stringify(sort), _obj ));
      }},scopedSlots:_vm._u([{key:"celpsdt",fn:function(item){return [_c('div',{staticClass:"pre-formatted",domProps:{"innerHTML":_vm._s(
            _vm.buildStartEndString(
              _vm.getROCDate(item.data.ceplcdt),
              _vm.getROCDate(item.data.celpsdt)
            )
          )}})]}},{key:"ceisdnm",fn:function(item){return [_c('span',{on:{"click":function($event){_vm.routeToCustDetail(item.data.ceisdno, item.data.ceisdnm)}}},[_vm._v("\n          "+_vm._s(_vm._f("truncate")(item.data.ceisdnm))+"\n        ")])]}},{key:"contract_type",fn:function(item){return [_vm._v("\n        "+_vm._s(_vm.translate.fireContractType[item.data.contract_type])+"\n      ")]}},{key:"premium",fn:function(item){return [_vm._v("\n        "+_vm._s(_vm._f("numberFormat")(item.data.premium1))+"元\n      ")]}},{key:"target_birth",fn:function(item){return [_vm._v("\n        "+_vm._s(item.data.target_birth ? item.data.target_birth + "年" : "")+"\n      ")]}},{key:"action",fn:function(item){return [_c('div',{staticClass:"dropdown"},[_c('a',{staticClass:"btn btn-icon btn-default btn-sm",attrs:{"data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false","role":"button"}},[_c('i',{staticClass:"icon-more"})]),_c('div',{staticClass:"dropdown-menu"},[_c('a',{staticClass:"dropdown-item text-green text-underline",attrs:{"role":"button"},on:{"click":function($event){_vm.toUpdate(item.data.pt_contractx_id)}}},[_vm._v("修改")]),_c('a',{staticClass:"dropdown-item text-green text-underline",attrs:{"role":"button"},on:{"click":function($event){_vm.doDelete(item.data)}}},[_vm._v("刪除")])])])]}}])},'data-table',props,false))]:undefined}}])})}
var staticRenderFns = []

export { render, staticRenderFns }